import React from "react";
import { UserPermissionsView } from "./UserPermissionsView";

const UserPermissionsReactView = () => {
  return <UserPermissionsView />;
};

window.UserPermissionsReactView = UserPermissionsReactView;
